module.exports = __webpack_public_path__ + "static/media/LunellaApartmentINTBRDamagedA0006_bg_clean_v001.adb6d9d9.webp";